import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/icons/index'

Vue.config.productionTip = false

import { Pagination, Icon, Input, Message, MessageBox, Drawer } from 'element-ui'


Vue.component(Pagination.name, Pagination)
Vue.component(Icon.name, Icon)
Vue.component(Input.name, Input)
Vue.component(Message.name, Message)
Vue.component(MessageBox.name, MessageBox)
Vue.component(Drawer.name, Drawer)

Vue.prototype.$message = Message

Vue.prototype.$confirm = MessageBox.confirm

Vue.prototype.$alert = MessageBox.alert

Vue.prototype.$prompt = MessageBox.prompt

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
